import { useState } from 'react'
import Collapse from '@mui/material/Collapse'
import Box from '@mui/material/Box'
import { SelectButton, Text } from '../1elements'
import CollapseArrowIcon from '../1elements/Icons/js/CollapseArrowIcon'

const CollapseForCard = ({
  header,
  dataCount,
  children,
  noAddButton,
  onClick,
  disabled
}) => {
  const [toggle, setToggle] = useState(true)

  return (
    <div>
      <Box sx={{ alignItems: 'center', display: 'flex', marginBottom: '2px', width: 'auto' }}>
        <CollapseArrowIcon toggle={toggle} setToggle={setToggle} />
        <Text type='detailNameDetailsHeader'>
          <strong>
            {header} ({dataCount})
          </strong>
        </Text>
      </Box>
      <Collapse in={toggle} timeout='auto' unmountOnExit>
        {children}
        {!noAddButton && (
          <Box sx={{ display: 'flex', marginBottom: '20px', width: '100%' }}>
            <SelectButton onClick={onClick} disabled={disabled} />
          </Box>
        )}
      </Collapse>
    </div>
  )
}

export default CollapseForCard
